/**
 * Asset Protection
 * Discourages casual saving of images and videos via right-click, drag, and long-press.
 * Handles both static and dynamically injected media (AJAX, search, cart drawer).
 * Controlled by theme setting: asset_protection_enabled
 */

(function () {
  const productOnly = window.themeSettings?.asset_protection_product_only;
  const currentTemplate = window.Theme?.template?.name;

  if (productOnly && currentTemplate !== 'product') {
    return;
  }

  document.body.classList.add('asset-protection-active');

  var PROTECTED_TAGS = ['IMG', 'VIDEO'];
  var SELECTOR = 'img, video';

  function protectElement(el) {
    if (el._assetProtected) return;
    el._assetProtected = true;

    el.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });

    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    if (el.tagName === 'VIDEO') {
      el.setAttribute('controlsList', (el.getAttribute('controlsList') || '') + ' nodownload');
    }
  }

  function protectAll() {
    document.querySelectorAll(SELECTOR).forEach(protectElement);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (PROTECTED_TAGS.indexOf(node.tagName) !== -1) {
          protectElement(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll(SELECTOR).forEach(protectElement);
        }
      }
    }
  });

  function init() {
    protectAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('pageTransitionComplete', protectAll);
})();
